import { Button } from 'blaze-ui/Button'
import Styles from './CancelSuccess.module.scss'

import { Heading } from 'blaze-ui/Heading/Heading'
import { Text } from 'blaze-ui/Text/Text'
import { Dayjs } from 'dayjs'

interface Props {
  onClose: () => void
  periodEnd: Dayjs
}
export const CancelSuccess = ({ onClose, periodEnd }: Props) => {
  return (
    <div>
      <div className={Styles.header}>
        <Heading level={2} color="var(--dark-80)">
          We appreciate your time and hope to see you again soon.
        </Heading>
      </div>
      <div className={Styles.content}>
        <Text variant="primary" color="var(--dark-80)">
          Your subscription is cancelled. You’ll have access to Blaze until {periodEnd.format('MMMM DD, YYYY')} when
          your subscription ends. Thanks for your interest in Blaze!
        </Text>
      </div>
      <div className={Styles.footer}>
        <Button size="lg" onPress={onClose}>
          Close
        </Button>
      </div>
    </div>
  )
}
